import React, { useState, useEffect } from 'react';
import css from "./FeaturedContractorsSlider.module.css";
import { useSelector } from "react-redux";
import { AvatarLarge, NamedLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

export default function FeaturedContractorsSlider() {
    const { featureContractors = [], fetchfeatureContractorsInProgress } = useSelector(state => state.user);
    const [SwiperComponents, setSwiperComponents] = useState(null);

    useEffect(() => {
        // Dynamic import to avoid ES module issues
        const loadSwiper = async () => {
            try {
                const { Swiper, SwiperSlide } = await import('swiper/react');
                setSwiperComponents({ Swiper, SwiperSlide });
            } catch (error) {
                console.error('Failed to load Swiper:', error);
            }
        };

        loadSwiper();
    }, []);

    if (fetchfeatureContractorsInProgress) {
        return (
            <div className={css.sliderWrapper}>
                <div className={css.sliderContent}>
                    <h1>Featured Contractors</h1>
                    <div>Loading...</div>
                </div>
            </div>
        );
    }

    if (featureContractors?.length == 0) {
        return null;
    }

    // Show loading state while Swiper is being loaded
    if (!SwiperComponents) {
        return (
            <div className={css.sliderWrapper}>
                <div className={css.sliderContent}>
                    <h1>Featured Contractors</h1>
                    <div>Loading slider...</div>
                </div>
            </div>
        );
    }

    const { Swiper, SwiperSlide } = SwiperComponents;

    return (
        <div className={css.sliderWrapper}>
            <div className={css.sliderContent}>
                <h1>Featured Contractors</h1>
                <Swiper
                    spaceBetween={25}
                    slidesPerView={4}
                    breakpoints={{
                        320: { slidesPerView: 1 },
                        640: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                        1400: { slidesPerView: 4 },
                    }}
                >
                    {featureContractors.map((contractor) => (
                        <SwiperSlide key={contractor.id.uuid}>
                            <div className={css.card}>
                                <div className={css.logo}>
                                    <AvatarLarge user={contractor} className={css.avatarDesktop}/>
                                </div>
                                <div className={css.content}>
                                    <h3 className={css.industry}>{contractor?.attributes?.profile?.publicData?.company_name || "Company Name"}</h3>
                                    <h3 className={css.title}>
                                        {(contractor?.attributes?.profile?.publicData?.businessCategory?.map(cat => cat.label) || ["Categories1", "Categories2", "Categories3"]).join(", ")}
                                    </h3>
                                    <div className={css.response}>
                                    </div>
                                    <NamedLink 
                                        className={css.viewButton} 
                                        name="ProfilePage" 
                                        params={{ id: contractor.id.uuid }}
                                    >
                                        <FormattedMessage id="UserCard.viewProfileLink" />
                                    </NamedLink>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
